import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home'
import Wip from './components/Wip'
import Booking from './components/booking/Booking'
import ObloBB from './components/ObloBB'
import Rooms from './components/Rooms'
import RoomTemplate from './components/RoomTemplate'
import Daytobb from './components/Daytobb'
import Services from './components/Services'
import Breakfast from './components/Breakfast'
import Contact from './components/Contact'
import Promo from './components/Promo'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'wip',
    //   component: Wip
    // }
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/daytobb',
      name: 'daytobb',
      component: Daytobb
    },
    {
      path: '/booking',
      name: 'booking',
      component: Booking
    },
    {
      path: '/oblobb',
      name: 'oblobb',
      component: ObloBB
    },
    {
      path: '/rooms',
      name: 'rooms',
      component: Rooms
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/breakfast',
      name: 'breakfast',
      component: Breakfast
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/promo',
      name: 'promo',
      component: Promo
    },
    {
      path: '/room/:roomName',
      name: 'room-template',
      component: RoomTemplate
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
